import { signInWithRedirect } from '@lastbrand/fe-common/universal-auth'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect, useCallback } from 'react'

import { Icon } from '@src/quince-components/src'
import LoaderWrapper from '@src/quince-components/src/atoms/loaderWrapper/LoaderWrapper'

import { getSanitizedRedirectUrls } from '../utils'

import GoogleSvg from './google_log.inline.svg'
import styles from './googleSignIn.module.scss'

const GOOGLE = 'Google'
const REDIRECT_URI = 'redirecturi'

const GoogleSignIn = () => {
  const { t } = useTranslation('common')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const eventListener = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setIsLoading(false)
      }
    }

    window.addEventListener('pageshow', eventListener)
    return () => {
      window.removeEventListener('pageshow', eventListener)
    }
  }, [])

  const onGoogleSignInButtonClick = useCallback(() => {
    const redirectUri = getSanitizedRedirectUrls()
    setIsLoading(true)
    if (redirectUri) {
      // eslint-disable-next-line @quince/no-direct-sessionstorage
      sessionStorage.setItem(REDIRECT_URI, JSON.stringify(redirectUri))
    }
    signInWithRedirect(GOOGLE).catch((e: unknown) => {
      console.error('Error while calling signInWithRedirect, onGoogleSignInButtonClick() runtime:: ', e)
    })
  }, [])

  return (
    <div
      onClick={onGoogleSignInButtonClick}
      className={isLoading ? styles.googleSignInButton__loading : styles.googleSignInButton}
    >
      {isLoading ? (
        <LoaderWrapper
          loadWrapperClassName={styles.pageLoader}
          showLoader
          containerClassName={styles.containerPageLoader}
        />
      ) : (
        <>
          <Icon iconSvg={GoogleSvg} className={styles.icon} />
          <div className={styles.loginText}>{t('continue_with_google')}</div>
        </>
      )}
    </div>
  )
}

export { GoogleSignIn }
